var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErr500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 251,
    viewBox: "0 0 400 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12142_223390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12142_223390)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68 253.413C92.0446 246.017 119.687 220.023 150.305 199.994C194.547 171.053 230.265 185.46 250.107 203.217C272.288 223.065 326.208 250.702 361.601 253.302C364.381 253.339 367.181 253.376 370 253.413C367.347 253.561 364.538 253.518 361.601 253.302C192.899 251.08 96.0703 250.566 68 253.413Z",
    fill: "url(#paint0_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M298.306 88.6652C298.306 88.6652 288.906 15.1097 233.445 67.9928C162.348 135.781 114.557 1.05032 61.8153 56.0461C33.0014 86.09 109.142 153.283 58.2908 188.644C7.43975 224.005 48.9942 250.477 48.9942 250.477H337.739C337.739 250.477 367.631 252.636 369.894 214.812C372.153 176.989 337.406 176.53 358.971 129.197C380.536 81.8647 305.083 118.792 298.306 88.6652Z",
    fill: "url(#paint1_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12142_223390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.287 112.783C166.287 117.384 162.566 121.104 157.926 121.104C157.846 121.104 157.166 121.104 152.165 121.104C148.684 121.104 143.123 121.104 134.242 121.104H130.001C124.441 121.224 120 116.784 120 111.423C120 106.022 124.481 101.541 130.121 101.821C134.962 86.6993 157.125 88.8196 159.006 104.462C163.166 104.982 166.287 108.502 166.287 112.783Z",
    fill: "url(#paint2_linear_12142_223390)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.926 121.104C162.526 121.104 166.287 117.384 166.287 112.783C166.287 108.182 162.526 104.462 157.926 104.462C153.325 104.462 149.564 108.182 149.564 112.783C149.564 117.384 153.325 121.104 157.926 121.104Z",
    fill: "url(#paint3_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.284 121.184C152.485 121.184 159.166 114.543 159.166 106.342C159.166 98.141 152.485 91.5 144.284 91.5C136.082 91.5 129.401 98.141 129.401 106.342C129.401 114.543 136.042 121.184 144.284 121.184Z",
    fill: "url(#paint4_linear_12142_223390)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M137 253.447C153.162 247.826 180.422 236.408 201.003 221.186C230.742 199.19 234.621 203.589 254.016 214.587C272.217 224.908 311.486 251.373 335.486 253.379C336.982 253.402 338.487 253.424 340 253.447C338.568 253.537 337.06 253.511 335.486 253.379C221.389 251.676 155.931 251.276 137 253.447Z",
    fill: "url(#paint5_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 253.452C106.162 248.417 133.422 238.189 154.003 224.552C183.742 204.847 187.621 208.788 207.016 218.641C225.217 227.887 264.486 251.595 288.486 253.392C289.982 253.412 291.487 253.432 293 253.452C291.568 253.533 290.06 253.51 288.486 253.392C174.389 251.866 108.931 251.507 90 253.452Z",
    fill: "url(#paint6_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 253.462C173.162 248.436 209.496 238.252 228.115 221.993C251.389 201.67 258.5 202.325 277.895 212.159C296.334 221.509 332.888 251.598 356.446 253.414C357.626 253.43 358.81 253.446 360 253.462C358.853 253.526 357.667 253.508 356.446 253.414C241.756 251.881 175.984 251.515 157 253.462Z",
    fill: "url(#paint7_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6279 250.028H323.769",
    stroke: "#9CACCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.404 250.028H367.408",
    stroke: "#9CACCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168.963,
    y: 219.583,
    width: 18.9126,
    height: 30.8906,
    rx: 5.04336,
    fill: "url(#paint8_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.983,
    y: 226.38,
    width: 18.9126,
    height: 30.8906,
    rx: 5.04336,
    transform: "rotate(-30 275.983 226.38)",
    fill: "url(#paint9_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12142_223390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.163 133.917C183.152 128.613 188.14 125.026 193.483 125.777L282.986 138.356C288.329 139.107 292.135 143.93 291.623 149.301L282.827 241.647C282.282 247.369 277.074 251.479 271.382 250.68L173.676 236.948C167.985 236.148 164.111 230.761 165.164 225.111L182.163 133.917Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.176 203.479L284.933 219.551L282.828 241.648C282.282 247.37 277.074 251.48 271.383 250.68L173.67 236.947C167.981 236.148 164.107 230.765 165.157 225.117L169.176 203.479Z",
    fill: "url(#paint10_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.507 120.087C201.251 115.81 205.677 113.264 210.251 113.907L270.159 122.326C274.733 122.969 278.286 126.637 278.783 131.229L279.477 137.641L197.072 126.06L199.507 120.087Z",
    fill: "url(#paint11_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.374,
    cy: 189.268,
    r: 14.4997,
    transform: "rotate(8 198.374 189.268)",
    stroke: "#9CACCE",
    strokeWidth: 2.52168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.151 182.151L198.379 191.497L188.989 179.036",
    stroke: "#9CACCE",
    strokeWidth: 2.52168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.894 219.571L169.073 203.479L172.51 185.315L223.68 192.506C226.993 192.972 229.83 195.116 231.181 198.177C232.532 201.236 235.368 203.38 238.68 203.847L285.797 210.484L284.894 219.571Z",
    fill: "url(#paint12_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.379,
    cy: 221.22,
    r: 5.98899,
    transform: "rotate(8 183.379 221.22)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.785,
    cy: 232.801,
    r: 5.98899,
    transform: "rotate(8 265.785 232.801)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.078,
    y: 219.213,
    width: 45.3903,
    height: 10.0867,
    rx: 5.04336,
    transform: "rotate(8 203.078 219.213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.358,
    y: 159.889,
    width: 13.2388,
    height: 28.3689,
    rx: 3.1521,
    transform: "rotate(8 297.358 159.889)",
    fill: "url(#paint13_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.456 152.057L300.196 153.286C302.954 153.673 304.876 156.224 304.488 158.982L304.137 161.479",
    stroke: "url(#paint14_linear_12142_223390)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.826 194.06L294.318 195.113C297.076 195.5 299.626 193.579 300.014 190.82L300.365 188.323",
    stroke: "url(#paint15_linear_12142_223390)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.2388,
    height: 28.3689,
    rx: 3.1521,
    transform: "matrix(-0.990268 -0.139173 -0.139173 0.990268 173.126 142.43)",
    fill: "url(#paint16_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.958 136.528L172.218 135.3C169.46 134.912 166.909 136.834 166.522 139.592L166.171 142.089",
    stroke: "url(#paint17_linear_12142_223390)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.831 178.179L166.34 177.127C163.581 176.739 161.66 174.189 162.047 171.43L162.398 168.933",
    stroke: "url(#paint18_linear_12142_223390)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 224.667L304.667 226.5L305.667 222.833L309.333 224.667L312 219.533H317.667L320 215.5",
    stroke: "url(#paint19_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.512,
    y1: 214.392,
    x2: 296.512,
    y2: 205.392,
    stroke: "url(#paint20_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.718,
    y1: 217.563,
    x2: 305.718,
    y2: 212.087,
    stroke: "url(#paint21_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 250,
    x2: 180,
    y2: 250,
    stroke: "#9CACCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.013 183.688C115.013 183.688 111.856 182.512 110.279 188.378C108.703 194.243 103.969 193.086 102.785 199.745C101.601 206.405 103.162 213.064 101.997 216.196C100.831 219.327 97.2632 224.436 100.024 230.691C102.785 236.946 109.095 240.875 117.774 238.523C126.453 236.171 134.747 236.957 135.916 223.249C137.085 209.54 125.661 212.671 126.057 206.798C126.453 200.925 132.367 198.963 128.029 193.479C123.692 187.996 120.535 189.561 118.562 186.037C116.59 182.512 115.013 183.688 115.013 183.688Z",
    fill: "url(#paint22_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.487 250.381L116.247 188.202H116.036L114.229 250.5L116.487 250.381Z",
    fill: "url(#paint23_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.666 234.661L100.79 224.428L115.507 233.2L114.666 234.661Z",
    fill: "url(#paint24_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.726 214.971L105.418 207.371L116.352 213.885L115.726 214.971Z",
    fill: "url(#paint25_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.352 227.353L130.228 217.121L115.507 225.889L116.352 227.353Z",
    fill: "url(#paint26_linear_12142_223390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.48 203.674L125.6 196.951L115.93 202.712L116.48 203.674Z",
    fill: "url(#paint27_linear_12142_223390)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12142_223390",
    x: 98,
    y: 80.5361,
    width: 90.2866,
    height: 73.5706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12142_223390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12142_223390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12142_223390",
    x: 136.992,
    y: 105.678,
    width: 174.677,
    height: 173.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.721569 0 0 0 0 0.792157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12142_223390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12142_223390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12142_223390",
    x1: -159.256,
    y1: 162.167,
    x2: 454.767,
    y2: 501.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12142_223390",
    x1: 33,
    y1: 42.5,
    x2: 177.12,
    y2: 331.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AACBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12142_223390",
    x1: 143.143,
    y1: 103.756,
    x2: 143.128,
    y2: 121.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12142_223390",
    x1: 148.675,
    y1: 102.67,
    x2: 156.087,
    y2: 110.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12142_223390",
    x1: 128.008,
    y1: 99.5315,
    x2: 139.69,
    y2: 104.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12142_223390",
    x1: -15.7584,
    y1: 190.871,
    x2: 400.787,
    y2: 416.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12142_223390",
    x1: -62.7584,
    y1: 197.395,
    x2: 331.758,
    y2: 435.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12142_223390",
    x1: 4.2416,
    y1: 190.871,
    x2: 420.787,
    y2: 416.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12142_223390",
    x1: 171.447,
    y1: 220.117,
    x2: 199.304,
    y2: 222.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12142_223390",
    x1: 278.467,
    y1: 226.915,
    x2: 306.325,
    y2: 229.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12142_223390",
    x1: 79.928,
    y1: 180.672,
    x2: 325.712,
    y2: 321.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12142_223390",
    x1: 137.58,
    y1: 99.425,
    x2: 270.98,
    y2: 216.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12142_223390",
    x1: 85.289,
    y1: 167.373,
    x2: 249.524,
    y2: 343.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12142_223390",
    x1: 287.396,
    y1: 151.244,
    x2: 321.006,
    y2: 152.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12142_223390",
    x1: 293.242,
    y1: 152.44,
    x2: 311.164,
    y2: 160.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12142_223390",
    x1: 288.484,
    y1: 194.161,
    x2: 306.422,
    y2: 191.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12142_223390",
    x1: -9.96228,
    y1: -8.64576,
    x2: 23.6478,
    y2: -6.93598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12142_223390",
    x1: 179.136,
    y1: 136.404,
    x2: 159.62,
    y2: 139.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12142_223390",
    x1: 172.21,
    y1: 177.819,
    x2: 155.608,
    y2: 170.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12142_223390",
    x1: 303.495,
    y1: 215.69,
    x2: 329.639,
    y2: 223.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12142_223390",
    x1: 295.28,
    y1: 213.322,
    x2: 302.32,
    y2: 210.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12142_223390",
    x1: 299.06,
    y1: 217.271,
    x2: 306.06,
    y2: 220.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12142_223390",
    x1: 71.1573,
    y1: 166.521,
    x2: 168.658,
    y2: 174.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12142_223390",
    x1: 114.526,
    y1: 189.279,
    x2: 117.885,
    y2: 189.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12142_223390",
    x1: 102.723,
    y1: 224.605,
    x2: 123.452,
    y2: 229.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12142_223390",
    x1: 106.854,
    y1: 207.503,
    x2: 122.254,
    y2: 211.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12142_223390",
    x1: 117.44,
    y1: 217.298,
    x2: 138.174,
    y2: 222.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12142_223390",
    x1: 117.2,
    y1: 197.067,
    x2: 130.821,
    y2: 200.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12142_223390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12142_223390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 337.31,
    height: 208.104,
    fill: "white",
    transform: "translate(33 42.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErr500);
export default __webpack_public_path__ + "static/media/err500.6bfbae2eada0d4f53768041f4b79aa03.svg";
export { ForwardRef as ReactComponent };